import React from 'react';
import i18next from 'i18next';
import { ButtonContent, ButtonSecondary } from '../../StyledComponents/Button';
import Loader from '../../StyledComponents/Loader';
import ProgressBar from '../../StyledComponents/ProgressBar';
import {
  Body,
  Footer,
  FooterAction,
  FooterProgress,
  Wrapper,
} from '../../StyledComponents/Result/wrapper';

interface SearchResultProps {
  count: number;
  totalHits: number;
  loadingMore?: boolean;
  children: React.ReactNode;
  loadMore?: () => void;
}

const SearchResult = ({
  count,
  totalHits,
  loadingMore,
  children,
  loadMore,
}: SearchResultProps) => {
  return (
    <Wrapper>
      <Body>{children}</Body>
      <Footer>
        <FooterProgress>
          <ProgressBar
            valueCurrent={count || 0}
            valueMax={totalHits || 0}
          />
        </FooterProgress>
        {loadMore && (
          <FooterAction>
            <ButtonSecondary
              disabled={loadingMore}
              onClick={loadMore}
              title={i18next.t('search.showMore.title') || ''}
            >
              <ButtonContent>{i18next.t('search.showMore.text')}</ButtonContent>
              {loadingMore && (
                <ButtonContent>
                  <Loader inline />
                </ButtonContent>
              )}
            </ButtonSecondary>
          </FooterAction>
        )}
      </Footer>
    </Wrapper>
  );
};

export default SearchResult;
